/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![WarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABjElEQVR4nO2Tzy4DcRDHK1xIxIGHIIREXGUfoPubmVZ+O7MH4izxDn0AcRQ8gAQPILhIJBq3Skk41UlKkJ5JS5bt7tb+rfbGL5nLzs7nO7/5fSeX+zPHRHtNkdScALBW+gsn2wCSFpB8uNFC5MW+wLXWg4BSCcC/A6VqGMZQzwIKZT0Ed8MZW09wouVxhfwcJwDEr6ZpT/TQPe/6I+EzrfWwaZojgHze/q6It38FB5AFhdwMzHzLy5HseALITbNgzXfLHwCUcuej8p4ngLz/I3fh1GSmK+TVsGv4yBeQ41A+624AwKhCfoiwZTnQwGXEg9e11mPp3RNvRjlGkdz6AnIX46qNRDgRTynkt5jieuAGjzHWfc8XrJmE7uU0zvPKcUvRnnSb8N0VfquTSLiJ9lL8Qoknkgj3d6PYAXcWCJDv0woB5UARH6YLSM1h+qNBLmWAV9v/A/F1htuWAgLykl4gDaVk+itQGhkaevIEgPgqtYC6DJSKJ5AvWHOK5KZ/AnytlMwm7sT/ybnnE3Ye6VHMw4ckAAAAAElFTkSuQmCC)
 */
export const WarningIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M10 3.1a2.37 2.37 0 0 1 4 0l8.71 14.75c.84 1.41-.26 3.15-2 3.15H3.29c-1.74 0-2.84-1.74-2-3.15L9.99 3.1Zm3.25 14.65a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM13.06 14l.37-5.94a1 1 0 0 0-1-1.06h-.87a1 1 0 0 0-1 1.06l.38 5.94a1.06 1.06 0 0 0 2.12 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
